'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapable = undefined;

var _recompose = require('recompose');

var addEscKeyHandler = (0, _recompose.withHandlers)({
  escKeyHandler: function escKeyHandler(_ref) {
    var onEscKeyDown = _ref.onEscKeyDown;
    return function (event) {
      if (event.which === 27 && onEscKeyDown) onEscKeyDown(event);
    };
  }
});

var attachAndRemoveEscKeyHandlers = (0, _recompose.lifecycle)({
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        escKeyHandler = _props.escKeyHandler,
        onEscKeyDown = _props.onEscKeyDown;


    if (onEscKeyDown) {
      document.body.addEventListener('keydown', escKeyHandler);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    var _props2 = this.props,
        escKeyHandler = _props2.escKeyHandler,
        onEscKeyDown = _props2.onEscKeyDown;


    if (onEscKeyDown) {
      document.body.removeEventListener('keydown', escKeyHandler);
    }
  }
});

var escapable = exports.escapable = (0, _recompose.compose)(addEscKeyHandler, attachAndRemoveEscKeyHandlers);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/wrappers.js
// module id = 202
// module chunks = 0